<template>
  <div class="home-contracts-layout">
    <!-- 左侧：合同进度 -->
    <div class="left-panel">
      <ContractProgress
        title="合同主页"
        ref="contractProgressRef"
        :contractProgressData="contractProgressData"
        :totalProgressCounts="totalProgressCounts"
        :loading="loading"
        :contractProgressSearchKeyword="contractProgressSearchKeyword"
        
        :progressPageSize="progressPageSize"
        :currentProgressPage="currentProgressPage"
        :showScheduleCard="false"
        :showFilterTool="true"
        @get-data="handleGetData"
        @aftersale-click="handleAftersaleClick"
        @contractinfo-click="handleContractLinkClick"
      />
    </div>

    <!-- 右侧：可折叠日历 -->
    <div class="right-panel-wrapper" :class="{ 'collapsed': !isCalendarExpanded }">
      <!-- 折叠按钮 -->
      <div class="collapse-btn" @click="toggleCalendar">
        <i class="el-icon-arrow-right" v-if="isCalendarExpanded"></i>
        <i class="el-icon-arrow-left" v-else></i>
        <span class="btn-text" v-if="!isCalendarExpanded">日历</span>
      </div>
      
      <!-- 日历内容 -->
      <transition name="slide-fade">
        <div class="right-panel schedule-card-mobile" v-show="isCalendarExpanded">
          <ScheduleCard />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ContractProgress from './contractProgress';
import ScheduleCard from './ScheduleCard';
import { getContractHomeList } from '@/api/mainapi.js';
import UserInfoUtils from '@/utils/userInfoUtils.js';

export default {
  name: 'homeContracts',
  components: { ContractProgress,ScheduleCard },

  data() {
    return {
      isCalendarExpanded: true,
      // 筛选条件
      columnFilterValues: {},
      contractProgressSearchKeyword: '',
      

      // 分页
      currentProgressPage: 1,
      progressPageSize: 50,

      // 数据
      contractProgressData: [],
      totalProgressCounts: 0,
      loading: false
    };
  },

  // mounted() {
  //   this.getContractProgressList();
  // },

activated() {
  if (!this._inited) {
    this.getContractProgressList();
    this._inited = true;
  }
},  

    methods: {
    // 新增：切换日历展开/收起
    toggleCalendar() {
      this.isCalendarExpanded = !this.isCalendarExpanded;
    },
    getCurrentUserCode() {
      const userCode = UserInfoUtils.getUserCode();
      if (!userCode) {
        this.$message.warning('未获取到用户信息，请重新登录');
        this.$router.push('/login');
        return null;
      }
      return userCode;
    },

    /** ✅ 获取合同进度列表（适配新接口） */
    async getContractProgressList(pageNo = this.currentProgressPage) {
      this.loading = true;
      const userCode = this.getCurrentUserCode();
      if (!userCode) return;

      // ✅ 从 columnFilterValues 里取
      const filter = this.columnFilterValues || {};

      const params = {
        contractName: filter['合同名称'] || '',
        contractNo: this.contractProgressSearchKeyword || '',
        reviewProgress: filter['评审进度'] || '',
        contractProgress: filter['合同进度'] || '',
        startDate: filter['创建时间'] ? filter['创建时间'][0] : '',
        endDate: filter['创建时间'] ? filter['创建时间'][1] : '',
        sortField: "field0211",
        customer: filter['客户'] || '',
        salesPerson: filter['销售员'] || '',
        updateStartDate: filter['更新日期'] ? filter['更新日期'][0] : '',      // ✅
        updateEndDate: filter['更新日期'] ? filter['更新日期'][1] : '',        // ✅
        reviewStartDate: filter['审核时间'] ? filter['审核时间'][0] : '',      // ✅
        reviewEndDate: filter['审核时间'] ? filter['审核时间'][1] : '',        // ✅
        signStartDate: filter['签订交货期'] ? filter['签订交货期'][0] : '',    // ✅
        signEndDate: filter['签订交货期'] ? filter['签订交货期'][1] : '',      // ✅
        replyStartDate: filter['回复交货期'] ? filter['回复交货期'][0] : '',   // ✅
        replyEndDate: filter['回复交货期'] ? filter['回复交货期'][1] : '',     // ✅
        userCode: userCode,
        department: filter['销售部门'] || '',
        projectNo: filter['项目编号'] || '',
        afterSalesNum: filter['售后总数量'] || '',
        branchNumber: filter['网点号'] || '',
        deliveryProgress: filter['交付进度'] || '',
        contractAmount: filter['销售金额'] || '',
        paymentRatio: filter['回款比例'] || '',
        hasException: filter['数据状态码'] || '',  // ✅ 状态列筛选：'true' = 只看有异常的合同，'' = 全部
        Paging_pageNumber: Number(pageNo),
        Paging_pageSize: Number(this.progressPageSize)
      };

      try {
        const res = await getContractHomeList(params);
        this.loading = false;

        if (res.data.code === 200) {
          const totalCount = parseInt(res.data.data.totalCount) || 0;

          // ✅ 关键判断：totalCount 为 0，直接清空
          if (totalCount === 0) {
            this.contractProgressData = [];
            this.totalProgressCounts = 0;
            this.$message.info('未查询到合同信息');
            return;
          }

          this.contractProgressData = 
            this.processContractData(res.data.data.contractInfo || []);
          this.totalProgressCounts = totalCount;
        } else {
          this.$message.error('获取数据失败');
        }
      } catch (err) {
        this.loading = false;
        this.$message.error('网络错误');
      }
    },

    /** ✅ 数据处理（适配新接口返回结构） */
    processContractData(data) {
      if (!Array.isArray(data)) return [];

      return data.map(item => {
        // ✅ 状态圆点颜色：hasException 优先（红色），其次按「评审进度」
        let 数据状态码 = '';
        let 状态详情 = item.评审进度 || '';
        if (item.hasException === true || item.hasException === 'true') {
          数据状态码 = 0; // 有异常 → 红色，优先级最高
          状态详情 = item.评审进度 ? `${item.评审进度}（存在异常，可点击查看异常详情）` : '存在异常';
        } else if (item.评审进度 === '已提交') 数据状态码 = 2;
        else if (item.评审进度 === '已审核') 数据状态码 = 1;
        else if (item.评审进度 === '暂存无用') 数据状态码 = 0;

        return {
          '创建时间': this.formatDate(item.创建时间),
          '审核时间': this.formatDate(item.审核时间),
          '合同编号': item.合同编号,
          '合同名称': item.合同名称 || item.合同编号,
          '评审进度': item.评审进度,
          '客户': item.客户,
          '销售员': item.销售员,
          '销售金额': item.合同总额 || item.合同金额_含税, // 优先使用合同总额
          '签订交货期': this.formatDate(item.签订交货期),
          '回复交货期': this.formatDate(item.回复交货期),
          '计划完成时间': this.formatDate(item.planFinishTime && item.planFinishTime.plandate),
          '交付进度': item.交付进度,
          '网点号': item.网点号,
          '总字号': item.总字号,
          '回款': item.回款总额 || item.回款总额_含税, // 优先使用回款总额
          '回款比例': Number(item.回款比例) > 1 ? 1 : Number(item.回款比例),
          '合同状态': item.合同进度, // 新接口使用合同进度作为状态
          '是否推送': '', // 新接口无此字段，暂留空
          'id': item.合同编号, // 使用合同编号作为唯一标识
          '数据状态码': 数据状态码,
          '状态详情': 状态详情, // 悬浮提示显示关联的评审进度文字（有异常时追加「存在异常」）
          // ✅ 后端新增字段：是否有异常（true → 状态圆点强制红色，可点击查看异常详情）
          'hasException': item.hasException === true || item.hasException === 'true',
          // 新增字段
          '销售部门': item.销售部门,
          '项目编号': item.项目编号,
          '工号': item.工号,
          '更新日期': this.formatDate(item.更新日期),
          'RN': item.RN,
          '售后总数量': item.售后总数量,
          // 有无问题：后端 hasIssue = true 表示有问题，统一成布尔值供「有无问题」列渲染（true→有 / false→无）
          'hasIssue': item.hasIssue === true || item.hasIssue === 'true',
          // 合同执行反馈：后端返回 { updateby, context, updatetime }，这里拍平成展示文本，对象本身也留着（回显更新人/时间用）
          'executeContent': item.executeContent || null,
          '合同执行反馈': (item.executeContent && item.executeContent.context) || ''
        };
      });
    },

  // ✅ 接收列筛选
  handleColumnFilterChange(filterValues) {
    this.columnFilterValues = filterValues;
  },

  // ✅ 接收 getData（关键）
  handleGetData(params) {
    // ✅ 同步列筛选
    if (params.columnFilterValues) {
      this.columnFilterValues = params.columnFilterValues;
    }

    this.currentProgressPage = params.currentPage;
    this.progressPageSize = params.pageSize;
    this.contractProgressSearchKeyword = params.contractNo;
    this.getContractProgressList();
  },

    handleContractLinkClick(data) {
      const contractNo = data.row.合同编号;
      const contractName = data.row.合同名称;

      // 缓存合同名称，供 contractinfo 面包屑显示
      sessionStorage.setItem(`contract_name_${contractNo}`, contractName || contractNo);

      this.$router.push({
        name: '合同信息',
        params: { contractId: contractNo }
      });

      this.$EventBus.$emit(
        'currentPath',
        `/homepage/contract/${contractNo}`
      );
    },

    handleAftersaleClick(data) {
      this.goToAftersaleInfo(data);
    },

    goToAftersaleInfo(data) {
      const contractNo = data.合同编号;
      const contractName = data.合同名称;

      // ✅ 缓存合同名称，供 afterSaleContract 面包屑显示
      sessionStorage.setItem(`contract_name_${contractNo}`, contractName || contractNo);

      this.$router.push({
        name: '合同售后信息1',
        params: {
          contractId: contractNo
        }
      });
      
      this.$EventBus.$emit(
        'currentPath',
        `/homepage/contract/${contractNo}/aftersale`
      );
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.length > 10 ? dateStr.slice(0, 10) : dateStr;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* homeContracts.vue scoped */
.home-contracts-layout {
  display: flex;
  height: 100%;                 /* ✅ 撑满 .main-view（homepage.vue 里 .main-view > * 本来也会强制 100%） */
  gap: 5px;
  overflow: hidden;

  // .left-panel {
  //   flex: 1;
  //   min-width: 0;
  //   overflow: auto;
  // }

  // .right-panel {
  //   width: 340px;
  //   min-width: 280px;
  //   max-width: 380px;
  //   display: flex;
  //   flex-direction: column;
  //   overflow: hidden;
  //   height: 100%;
  // }
}

/* ✅ 强制 ScheduleCard 使用手机布局 */
.schedule-card-mobile {
  ::v-deep .schedule-card-new {
    height: 100%;
    display: flex;
    flex-direction: column;

    .main-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;   // ✅ 防止 flex 子项溢出
    }

    /* ✅ 日历：固定高度 */
    .calendar-section {
      width: 100% !important;
      height: 180px;          // ✅ 你想要的固定高度
      // max-height: 180px;
      flex-shrink: 0;         // ✅ 不被压缩
      overflow: hidden;
    }

    /* ✅ 异常：吃满剩余 */
    .exception-section {
      width: 100% !important;
      flex: 1;
      min-height: 0;
      border-left: none !important;
      padding-left: 0 !important;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      padding-top: 8px;
      padding-bottom: 8px;
      margin-top: 0;
      // margin-bottom: 8px;
      display: flex;
      flex-direction: column;

    }

    /* ✅ 异常列表滚动 */
    .exception-list-container {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
    }
  }
}
.home-contracts-layout {
  display: flex;
  height: 100%;                 /* ✅ 撑满 .main-view（和 homeWorkOrders 一样：直接吃满 card-main） */
  gap: 1px;
  overflow: hidden;
  position: relative;

  .left-panel {
    flex: 1;
    min-width: 0;
    height: 100%;              /* ✅ 撑满 .home-contracts-layout 的高度 */
    display: flex;             /* ✅ 让里面的合同卡片能撑满 */
    flex-direction: column;
    overflow: auto;            /* ✅ 保留：窗口窄到 .contract 的 min-width:350px 装不下时还能横向滚，不会被裁 */

    /* ✅ 合同主页卡片（ContractProgress 的根 .contract）撑满 left-pane —— 高度 + 宽度都占满
       ⚠️ contractProgress.vue 里给 .contract 写死了 height: calc(100vh - 65px)：
          那是「视口高度」，不是「left-pane 的真实高度」。
          只要两者不相等（main-view 有 min-height 兜底、或页面还有别的占位），
          卡片就会短一截（底部留白）或者溢出被裁。
          这里覆盖成 100% + flex:1，才能真正「高度和宽度都占满 left-pane」。 */
    ::v-deep .contract {
      height: 100% !important;
      width: 100% !important;
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
  }

  .right-panel-wrapper {
    width: 340px;
    min-width: 280px;
    max-width: 380px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    height: 100%;
    transition: all 0.3s ease;
    
    &.collapsed {
      width: 40px;
      min-width: 40px;
      max-width: 40px;
    }
    
    .collapse-btn {
      width: 24px;
      height: 80px;
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      border-radius: 0 8px 8px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: white;
      font-size: 12px;
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
      z-index: 10;
      transition: all 0.3s ease;
      margin-top: 20px;
      
      &:hover {
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        box-shadow: 2px 0 12px rgba(64, 158, 255, 0.3);
      }
      
      i {
        font-size: 14px;
        margin-bottom: 4px;
      }
      
      .btn-text {
        writing-mode: vertical-rl;
        letter-spacing: 2px;
        font-weight: 500;
      }
    }
    
    .right-panel {
      flex: 1;
      min-width: 0;
      height: 100%;
      transition: all 0.3s ease;
      overflow: hidden;
    }
  }
}

/* 过渡动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* ================= 移动端：完全保持原样 ================= */
@media (max-width: 768px) {
  .home-contracts-layout {
    flex-direction: column !important;
    height: 100% !important;      /* ✅ 手机端同样撑满 .main-view，不再写死 vh */
    overflow: hidden;
    gap: 5px;

    /* ✅ 日历区域：永远正常显示 */
    .right-panel-wrapper {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 100% !important;
      order: 1;
      height: 350px;
      margin-bottom: 0;

      /* ✅ 忽略 PC 的折叠状态 */
      &.collapsed {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 100% !important;
        display: flex !important;
      }

      /* ✅ 移动端：折叠按钮直接隐藏 */
      .collapse-btn {
        display: none !important;
      }
    }

    /* ✅ 合同列表：占满剩余空间 */
    .left-panel {
      order: 2;
      width: 100% !important;
      flex: 1 !important;
      min-height: 0;
      overflow: auto !important;
    }
  }
}
</style>
